import type { NavigateFunction } from 'react-router-dom';

function shouldNavigateInternally(parsed: URL): boolean
{
  if (parsed.origin === window.location.origin)
  {
    return true;
  }

  const hostname = parsed.hostname.toLowerCase();
  return hostname === 'localhost' || hostname === '127.0.0.1';
}

export function navigateNotificationActionUrl(url: string, navigate: NavigateFunction): void
{
  const trimmed = url.trim();
  if (trimmed.length === 0)
  {
    return;
  }

  try
  {
    if (/^https?:\/\//i.test(trimmed))
    {
      const parsed = new URL(trimmed);
      if (shouldNavigateInternally(parsed))
      {
        navigate(parsed.pathname + parsed.search + parsed.hash);
        return;
      }

      window.open(trimmed, '_blank', 'noopener,noreferrer');
      return;
    }

    if (trimmed.startsWith('/'))
    {
      navigate(trimmed);
      return;
    }

    navigate(`/${trimmed}`);
  }
  catch
  {
    window.open(trimmed, '_blank', 'noopener,noreferrer');
  }
}
